import { render, staticRenderFns } from "./userCabinet.vue?vue&type=template&id=0a24d970&scoped=true&"
import script from "./userCabinet.vue?vue&type=script&lang=js&"
export * from "./userCabinet.vue?vue&type=script&lang=js&"
import style0 from "./userCabinet.vue?vue&type=style&index=0&id=0a24d970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a24d970",
  null
  
)

export default component.exports